/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Radio,
} from 'antd';
import { OnAddorUpdateShipmentNumber } from '../../redux/ShipmentDetails/saga';
import {
  SHIPMENT_PRIORITY_OPTIONS,
  SHIPMENT_CATEGORY_OPTIONS,
  SHIPMENT_PACKAGING_OPTIONS,
  normalizeShipmentMetaFromRecord,
  packagingFormValueToApi,
  getPopupContainerBody,
} from './shipmentFieldOptions';

const { Option } = Select;

const AddNewShipmentNumber = (props) => {
  const {
    showAddModel,
    setShowAddModel,
    selectedData,
    editRecord,
    setIsEdit,
    isEdit,
    OnfetchData,
  } = props;

  const [shipmentNumber, setShipmentNumber] = useState('');
  const [priority, setPriority] = useState('medium');
  const [shipmentCategory, setShipmentCategory] = useState('project');
  const [packagingSubcategory, setPackagingSubcategory] = useState(undefined);
  const [addLoading, setAddLoading] = useState(false);
  const [equipTypeForm] = Form.useForm();

  useEffect(() => {
    if (!showAddModel) return;
    if (isEdit && editRecord) {
      const num =
        editRecord.shipmentNumber ??
        editRecord.shipment_number ??
        '';
      setShipmentNumber(String(num));
      const meta = normalizeShipmentMetaFromRecord(editRecord);
      setPriority(meta.priority);
      setShipmentCategory(meta.shipmentCategory);
      setPackagingSubcategory(meta.packagingSubcategory);
    } else if (!isEdit) {
      setShipmentNumber('');
      const meta = normalizeShipmentMetaFromRecord(null);
      setPriority(meta.priority);
      setShipmentCategory(meta.shipmentCategory);
      setPackagingSubcategory(undefined);
    }
  }, [showAddModel, isEdit, editRecord]);

  const handleOk = async () => {
    const num = String(shipmentNumber || '').trim();
    if (!num) {
      notification.warning({
        message: 'Please enter a shipment number to proceed!',
      });
      return;
    }
    if (!packagingSubcategory) {
      notification.warning({
        message: 'Please select packaging (subcategory) to proceed!',
      });
      return;
    }

    const shipmentPayload = {
      shipmentTypeId: selectedData.id,
      shipmentNumber: num,
      priority,
      shipmentCategory,
      packagingType: packagingFormValueToApi(packagingSubcategory),
    };

    let obj = { shipment: shipmentPayload };
    if (isEdit) {
      obj = {
        id: editRecord.id,
        data: { shipment: shipmentPayload },
      };
    }
    setAddLoading(true);
    const res = await OnAddorUpdateShipmentNumber(obj, isEdit);
    if (res) await OnfetchData();
    setAddLoading(false);

    resetLocal();
    setIsEdit(false);
    setShowAddModel(false);
  };

  const resetLocal = () => {
    setShipmentNumber('');
    setPriority('medium');
    setShipmentCategory('project');
    setPackagingSubcategory(undefined);
  };

  const handleCancel = () => {
    setShowAddModel(false);
    resetLocal();
    setIsEdit(false);
  };

  return (
    <div>
      <Modal
        className="pipeline-modal shipment-add-modal"
        title={isEdit ? 'Update Shipment Number' : 'Create New Shipment Number'}
        centered
        visible={showAddModel}
        onCancel={handleCancel}
        width={560}
        destroyOnClose
        bodyStyle={{
          maxHeight: 'calc(100vh - 220px)',
          overflowY: 'auto',
          padding: '16px 24px 8px',
        }}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
          >
            {'Cancel'}
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleOk}
            loading={addLoading}
          >
            {isEdit ? 'Update' : 'Add'}
          </Button>,
        ]}
      >
        <Form
          form={equipTypeForm}
          name="basic"
          layout="vertical"
          autoComplete="off"
          getContainer={false}
        >
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <Form.Item
                label="Priority"
                required
              >
                <Select
                  className="client-select"
                  placeholder="Select priority"
                  value={priority}
                  onChange={setPriority}
                  getPopupContainer={getPopupContainerBody}
                >
                  {SHIPMENT_PRIORITY_OPTIONS.map((o) => (
                    <Option
                      key={o.value}
                      value={o.value}
                    >
                      {o.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <Form.Item
                label="Category"
                required
              >
                <Radio.Group
                  className="shipment-category-radio-group"
                  value={shipmentCategory}
                  onChange={(e) => setShipmentCategory(e.target.value)}
                >
                  {SHIPMENT_CATEGORY_OPTIONS.map((o) => (
                    <Radio
                      key={o.value}
                      value={o.value}
                    >
                      {o.label}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <Form.Item
                label="Subcategory (packaging)"
                required
              >
                <Select
                  className="client-select"
                  placeholder="Select packaging type"
                  allowClear
                  value={packagingSubcategory}
                  onChange={setPackagingSubcategory}
                  getPopupContainer={getPopupContainerBody}
                >
                  {SHIPMENT_PACKAGING_OPTIONS.map((o) => (
                    <Option
                      key={o.value}
                      value={o.value}
                    >
                      {o.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <Form.Item
                label="Shipment Number"
                required
              >
                <Input
                  placeholder={'Enter shipment number'}
                  value={shipmentNumber}
                  onChange={(e) => setShipmentNumber(e.target.value)}
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default AddNewShipmentNumber;
